import Auth from '../../modules/auth';

const AuthPage = () => {
  return <Auth />;
};

export default AuthPage;
